import React, { Component } from 'react'
import { array, object, bool } from 'prop-types'
import { Grid } from '@ycos/component-grid'
import { hasTag } from '@ycos/coremedia-renderer'
import { ThemeProvider, withTheme } from '@ycos/fela'
import SpanContainer from './SpanContainer'

const getColumnConfiguration = (layoutVariant) => {
  return {
    'isc-single-column-fullbleed': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 0,
        width: 12
      },
      fullBleed: true
    },
    'isc-single-column-large': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 0,
        width: 12
      }
    },
    // DEPRECATED: should not be used (part of the renaming process), remove as soon all heads migrate and the CM layoutVariant is deleted
    'isc-single-column': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 1,
        width: 10
      }
    },
    'isc-single-column-medium-large': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 0,
        width: 12
      },
      large: {
        offset: 1,
        width: 10
      }
    },
    'isc-single-column-medium': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 1,
        width: 10
      }
    },
    'isc-single-column-small': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 2,
        width: 8
      },
      large: {
        offset: 3,
        width: 6
      }
    },
    'isc-single-column-x-small': {
      small: {
        offset: 1,
        width: 4
      },
      medium: {
        offset: 3,
        width: 6
      },
      large: {
        offset: 4,
        width: 4
      }
    },
    'isc-single-column-left-prominence': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 1,
        width: 6
      }
    },
    'isc-single-column-right-prominence': {
      small: {
        offset: 0,
        width: 6
      },
      medium: {
        offset: 5,
        width: 6
      }
    }
  }[layoutVariant]
}

class SingleColumn extends Component {
  static layoutVariant = [
    'isc-single-column-fullbleed',
    'isc-single-column-large',
    'isc-single-column', // DEPRECATED
    'isc-single-column-medium-large',
    'isc-single-column-medium',
    'isc-single-column-small',
    'isc-single-column-x-small',
    'isc-single-column-left-prominence',
    'isc-single-column-right-prominence'
  ]

  render() {
    const { layoutVariant = 'isc-single-column' } = this.props.item
    const children = React.Children.toArray(this.props.children)
    const columnConfiguration = getColumnConfiguration(layoutVariant)
    const fullBleedConf = {
      small: hasTag(this.props.item.tags, 'Columns.FullBleed.Small'),
      medium: hasTag(this.props.item.tags, 'Columns.FullBleed.Medium'),
      large: hasTag(this.props.item.tags, 'Columns.FullBleed.large'),
      xlarge: hasTag(this.props.item.tags, 'Columns.FullBleed.XLarge'),
      sizes: getColumnConfiguration('isc-single-column-fullbleed')
    }
    const noPaddingTop = this.props.noPaddingTop || hasTag(this.props.item.tags, 'Columns.NoTopPadding')
    const noPaddingTopMobile = this.props.noPaddingTopMobile || hasTag(this.props.item.tags, 'Columns.NoTopPaddingMobile')
    const addPaddingBottom = this.props.addPaddingBottom || hasTag(this.props.item.tags, 'Columns.AddBottomPadding')
    const addPaddingBottomMobile = this.props.addPaddingBottomMobile || hasTag(this.props.item.tags, 'Columns.AddBottomPaddingMobile')
    const centerContent = this.props.center || hasTag(this.props.item.tags, 'Columns.Center')
    const viewportHeight = this.props.viewportHeight || hasTag(this.props.item.tags, 'Columns.ViewportHeight')
    const verticallyCenter = this.props.verticallyCenter || hasTag(this.props.item.tags, 'Columns.VerticallyCenter')

    return (
      <ThemeProvider theme={{ ...this.props.theme, direction: 'ltr' }}>
        <Grid.Row fullBleedConf={fullBleedConf} fullBleed={columnConfiguration.fullBleed} verticallyCenter={verticallyCenter} data-automation={`${layoutVariant}-row`}>
          {children.map((child) => (
            <Grid.Span
              key={child.key}
              small={{ ...columnConfiguration.small }}
              medium={{ ...columnConfiguration.medium }}
              large={{ ...columnConfiguration.large }}
              xlarge={{ ...columnConfiguration.xlarge }}
              data-automation={`${layoutVariant}-span`}
              fullBleedConf={fullBleedConf}
              fullBleed={columnConfiguration.fullBleed}
            >
              <SpanContainer
                centerContent={centerContent || verticallyCenter}
                noPaddingTop={noPaddingTop}
                noPaddingTopMobile={noPaddingTopMobile}
                addPaddingBottom={addPaddingBottom}
                addPaddingBottomMobile={addPaddingBottomMobile}
                viewportHeight={viewportHeight}
                data-automation={`${layoutVariant}-span-container`}
              >
                <ThemeProvider theme={this.props.theme}>
                  {child}
                </ThemeProvider>
              </SpanContainer>
            </Grid.Span>
          ))}
        </Grid.Row>
      </ThemeProvider>
    )
  }
}

SingleColumn.propTypes = {
  children: array,
  item: object,
  noPaddingTop: bool,
  noPaddingTopMobile: bool,
  addPaddingBottom: bool,
  addPaddingBottomMobile: bool,
  center: bool,
  viewportHeight: bool,
  verticallyCenter: bool
}

SingleColumn.defaultProps = {
  children: [],
  item: {},
  noPaddingTop: false,
  noPaddingTopMobile: false,
  addPaddingBottom: false,
  addPaddingBottomMobile: false,
  center: false,
  viewportHeight: false,
  verticallyCenter: false
}

export default withTheme(SingleColumn)
